module.exports = __webpack_public_path__ + "static/media/lcg-shape-dark-blue-up.25a58851.svg";